@if (renderWidgets) {
    <dp-widgets [widgets]="widgets"></dp-widgets>
}